export default __webpack_public_path__ + "static/media/ie.1b0ac4e7.svg";